var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomFitSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 76,
    viewBox: "0 0 70 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7086_3819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 28,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2539H27.83V55.2724H0V20.2539Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7086_3819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0126953 47.9287C0.0126953 32.7624 12.3377 20.4688 27.5411 20.4688V30.7234C25.3244 30.2452 23.2165 31.9253 23.2165 34.2005C23.2165 36.4756 25.3244 38.1557 27.5411 37.6775V47.9287L13.584 55.1085L0.0126953 47.9287Z",
    fill: "#FA6E85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7086_3819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 47,
    width: 36,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.7871H35.6118V75.385H0V47.7871Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7086_3819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5411 75.3877C12.3377 75.3877 0.0126953 63.0928 0.0126953 47.9277H10.294C9.81353 50.1386 11.4982 52.2419 13.7792 52.2419C16.0602 52.2419 17.7438 50.1386 17.2644 47.9277H27.5411L35.3988 62.2511L27.5411 75.3877Z",
    fill: "#19CFBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7086_3819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 43,
    width: 29,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5303 43.5977H55.365V75.3858H27.5303V43.5977Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7086_3819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0694 47.9255C55.0694 63.0906 42.7444 75.3854 27.541 75.3854V65.1296C29.7577 65.6078 31.8656 63.9289 31.8656 61.6526C31.8656 59.3774 29.7577 57.6973 27.541 58.1767V47.9255H37.8177C37.3372 45.7135 39.0219 43.6113 41.3029 43.6113C43.5838 43.6113 45.2686 45.7135 44.788 47.9255H55.0694Z",
    fill: "#FFBF31"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3149 14.627H56.0467C57.3257 14.627 58.3721 15.671 58.3721 16.9466V35.6332C58.3721 36.9087 57.3257 37.9528 56.0467 37.9528H37.3149C36.0358 37.9528 34.9883 36.9087 34.9883 35.6332V16.9477C34.9883 15.671 36.0358 14.627 37.3149 14.627Z",
    fill: "#60B7FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8823 14.627H49.4778V22.652C49.4778 23.592 48.7062 24.3602 47.7638 24.3602H45.5963C44.654 24.3602 43.8823 23.592 43.8823 22.652V14.627Z",
    fill: "#4187B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7086_3819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 42,
    height: 26
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7285 0H70V25.041H28.7285V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7086_3819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8252 22.6952C69.467 22.6952 69.9873 23.2143 69.9873 23.855C69.9873 24.4957 69.467 25.0148 68.8252 25.0148H66.1069C65.4639 25.0148 64.9436 24.4957 64.9436 23.855C64.9436 23.2143 65.4639 22.6952 66.1069 22.6952H68.8252ZM61.338 6.98413C61.7917 6.53167 62.5282 6.53167 62.9818 6.98413C63.4366 7.43776 63.4366 8.17199 62.9818 8.62446L61.0598 10.5419C60.6062 10.9955 59.8696 10.9955 59.416 10.5419C58.9612 10.0894 58.9612 9.35518 59.416 8.90271L61.338 6.98413ZM29.1565 8.62446C28.7017 8.17199 28.7017 7.43776 29.1565 6.98413C29.6101 6.53167 30.3467 6.53167 30.8003 6.98413L32.7224 8.90271C33.1772 9.35518 33.1772 10.0894 32.7224 10.5419C32.2688 10.9955 31.5322 10.9955 31.0786 10.5419L29.1565 8.62446ZM44.9059 1.1559C44.9059 0.515198 45.4273 -0.00390625 46.0692 -0.00390625C46.711 -0.00390625 47.2313 0.515198 47.2313 1.1559V3.86833C47.2313 4.50903 46.711 5.02814 46.0692 5.02814C45.4273 5.02814 44.9059 4.50903 44.9059 3.86833V1.1559Z",
    fill: "#4187B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFitSolutions);
export default __webpack_public_path__ + "static/media/custom_fit_solutions.5490a22961441b42976ef2af8329b102.svg";
export { ForwardRef as ReactComponent };